<template>

  <div class="mit-user-page mit-page">
      <MitEditUser :show="showOverlay" :editUser="editUser" v-on:save="saveUser" v-on:cancel="cancelDialog"/>
      <v-container>
        <v-row>
          <v-col cols="12" class="d-flex justify-left">
            <v-btn @click="showCreateUserDialog()">Add User</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-left">
            <div class="pa-2">
              <h3 class="pb-2">TIG Users</h3>
              <v-toolbar flat class="mb-2">
                <v-text-field class="mr-10" hide-details solo placeholder="Enter csail id" v-model="searchOptions.csailId"></v-text-field>
                <v-text-field class="mr-10" hide-details solo placeholder="Enter csail email" v-model="searchOptions.csailEmail"></v-text-field>
                <v-btn @click="getUsers()">Refresh</v-btn>
              </v-toolbar>
              <v-data-table
                :headers="headers"
                :items="users"
                :items-per-page="paging.pageSize"
                :server-items-length="paging.totalItems"
                :page="paging.page"
                class="elevation-1"
                @pagination="updatePagination"
              >
                <template v-slot:item.action="{ item }">
                  <v-btn @click="showEditUserDialog(item)">EDIT</v-btn>
                </template>
              </v-data-table>
            </div>
          </v-col>
        </v-row>
    </v-container>
  </div>
</template>

<script>
  import {MitEventBus} from '../../main.js';
  import BaseMitLoading from '../../base/components/BaseMitLoading.vue';
  import MitEditUser from '../components/MitEditUser.vue';
  import MitUserService from '../services/MitUserService.js';

  export default {
    name: 'MitUserPage',
    components: {
      BaseMitLoading,
      MitEditUser
    },
    data: function() {
      return {
        headers: [
                    {
                      text: 'Csail id',
                      align: 'start',
                      sortable: true,
                      value: 'csailId',
                    },
                    { text: 'Email', value: 'csailEmail' },
                    { text: 'Role', value: 'role' },
                    { text: 'Groups', value: 'groups' },
                    { text: 'First Name', value: 'fname' },
                    { text: 'Last Name', value: 'lname' },
                    { text: 'Created', value: 'createDate' },
                    { text: 'Last Edited', value: 'lastEditedDate' },
                    { text: "", value: "action" }
                  ],
        users: [],
        editUser: null,
        roleNames:null,
        paging:{
          page:1,
          pageSize:5,
          totalItems:0
        },
        searchOptions:{
          csailId:null,
          csailEmail:null,
          fname:null,
          lname:null
        },
        showOverlay:false,
        test:{}
      }
    },
    props: {
      userModel: Object, //comes from route
      userRoles: Object //comes from route
    },
    created() {
      //set a default of new user for now. This will get updated if a user edits someone
      this.editUser = MitUserService.getNewDefaultUser();

      this.getUsers();

      MitUserService.getRoleNames()
        .then((roleNames) => {
          this.roleNames = roleNames;
        })
        .catch((error) => {
          console.log('An error occurred trying to get user list', error);
        });
    },
    methods: {
      showCreateUserDialog(){
        this.editUser = MitUserService.getNewDefaultUser();
        this.showOverlay = true;
      },
      showEditUserDialog (item){
        this.editUser = item;
        this.showOverlay = true;
      },
      updatePagination (pagination) {
        this.paging.page = pagination.page;
        this.paging.pageSize = pagination.itemsPerPage;

        this.getUsers();
      },
      cancelDialog(){
        this.showOverlay = false;
      },
      saveUser(){
        MitUserService.saveUser(this.editUser)
          .then((user) => {
            this.getUsers();
          })
          .catch((error) => {
            console.log('An error occurred saving user', error);

            MitEventBus.$emit('mit-alert--set-alert', {
              message:'An error occurred trying to create user.',
              timeoutMs:3000
            });

          });
          this.showOverlay = false;
      },
      getUsers(){
        MitUserService.getUsers( this.paging.page, this.paging.pageSize, this.searchOptions)
          .then((users) => {
            this.users = users.data;
            this.paging.totalItems = users.total;
          })
          .catch((error) => {
            console.log('An error occurred trying to get user list', error);

            MitEventBus.$emit('mit-alert--set-alert', {
              message:'An error occurred trying get list of users.',
              timeoutMs:3000
            });
          });
      },
    }
  }
</script>

<style lang="scss" scoped>
  .mit-app-loading-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height:100vh;
  }
</style>
